import { Component, Input, OnChanges } from '@angular/core';
import { TenantSettings } from 'projects/common/src/lib/constants/jurisdiction/TenantSettings';

@Component({
  selector: 'lib-board-validation-error',
  templateUrl: './board-validation-error.component.html',
})
export class BoardValidationErrorComponent implements OnChanges {
  @Input() unlicensedDirectorsCount: number;
  @Input() directorsInStateCount: number;

  increaseInstateDirectorsTo: number;
  decreaseOutOfStateDirectorsTo: number;

  constructor(public settings: TenantSettings) {}

  ngOnChanges(): void {
    this.increaseInstateDirectorsTo = this.unlicensedDirectorsCount + 1;
    if (this.directorsInStateCount === 1) {
      this.decreaseOutOfStateDirectorsTo = 1;
    } else {
      this.decreaseOutOfStateDirectorsTo = this.directorsInStateCount - 1;
    }
  }
}
